import React from 'react'

interface ErrorBoundaryState {
  hasError: boolean
  error: any
  errorInfo: { componentStack: string } | null
}

interface ErrorBoundaryProps {
  message?: string
  hidden?: boolean
}

export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo })
    // 这里可以上报错误到服务端
    // logErrorToService(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return this.props.hidden ? (
        ''
      ) : (
        <div
          style={{
            color: 'red',
            width: '100%',
            height: '100%',
            textAlign: 'center',
          }}>
          {this.props.message || '出了点问题'}
        </div>
      )
    }
    return this.props.children
  }
}
